import React from "react";

import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";

import Info from "@material-ui/icons/Info";

const PreCheck = (props) => {
  const { actions, portfolio } = props;

  const { portfolioCheck = {} } = portfolio;

  return (
    <div style={{ fontSize: 14 }}>
      <div style={{ display: "flex", margin: 10 }}>
        <div style={{ width: "100%" }}></div>
        <div style={{ width: "10%", textAlign: "center" }}>Yes</div>
        <div style={{ width: "10%", textAlign: "center" }}>No</div>
      </div>
      <Divider />
      <div style={{ display: "flex", margin: 10 }}>
        <div style={{ width: "100%", padding: 15 }}>
          Does the portfolio contain assets that are not market traded?
        </div>
        <div style={{ width: "10%", textAlign: "center" }}>
          <Checkbox
            color={"primary"}
            checked={portfolioCheck.nonMarket === "y"}
            onChange={(e) => {
              actions.setPortfolioValue(
                props,
                portfolio.portfolioNumber,
                "portfolioCheck",
                {
                  ...portfolioCheck,
                  nonMarket: "y",
                }
              );
            }}
          />
        </div>
        <div style={{ width: "10%", textAlign: "center" }}>
          <Checkbox
            color={"primary"}
            checked={portfolioCheck.nonMarket === "n"}
            onChange={(e) => {
              actions.setPortfolioValue(
                props,
                portfolio.portfolioNumber,
                "portfolioCheck",
                {
                  ...portfolioCheck,
                  nonMarket: "n",
                }
              );
            }}
          />
        </div>
      </div>
      {portfolioCheck.nonMarket === "y" && (
        <div>
          <Divider />
          <div style={{ display: "flex", margin: 10 }}>
            <div style={{ width: "100%", padding: 15 }}>
              Are the non-market traded assets given a value by the portfolio
              manager in every month of the analysis period?{" "}
            </div>
            <div style={{ width: "10%", textAlign: "center" }}>
              <Checkbox
                color={"primary"}
                checked={portfolioCheck.nonGiven === "y"}
                onChange={(e) => {
                  actions.setPortfolioValue(
                    props,
                    portfolio.portfolioNumber,
                    "portfolioCheck",
                    {
                      ...portfolioCheck,
                      nonGiven: "y",
                    }
                  );
                }}
              />
            </div>
            <div style={{ width: "10%", textAlign: "center" }}>
              <Checkbox
                color={"primary"}
                checked={portfolioCheck.nonGiven === "n"}
                onChange={(e) => {
                  actions.setPortfolioValue(
                    props,
                    portfolio.portfolioNumber,
                    "portfolioCheck",
                    {
                      ...portfolioCheck,
                      nonGiven: "n",
                    }
                  );
                }}
              />
            </div>
          </div>
        </div>
      )}
      {portfolioCheck.nonMarket === "y" && portfolioCheck.nonGiven === "n" && (
        <div>
          <Divider />
          <div style={{ display: "flex", color: "#3e51b4" }}>
            <div style={{ padding: 10 }}>
              <Info />
            </div>
            <div style={{ padding: 10 }}>
              <p>
                If your Portfolio monthly reports have Non-traded assets, you
                have two choices. They must have a value in every month end, in
                the analysis currency, and you may simply add those asset values
                to each month’s closing value. Nothing else is required.
              </p>
              <p>
                Alternatively, you may omit those assets from the Portfolio by
                removing any month-end non-zero Values, and monthly
                Contributions, Withdrawals, and Management Fees that were caused
                by the nontraded assets. If every month end value is zero and no
                Transfers existed, no action is required.
              </p>
            </div>
          </div>
        </div>
      )}
      {(portfolioCheck.nonMarket === "n" ||
        (portfolioCheck.nonMarket === "y" && portfolioCheck.nonGiven)) && (
        <div>
          <div>
            <Divider />
            <div style={{ display: "flex", margin: 10 }}>
              <div style={{ width: "100%", padding: 15 }}>
                {portfolio.currencyType === "USD"
                  ? "Does the portfolio contain non-USA assets?"
                  : "Does the portfolio contain non-Canadian assets?"}
              </div>
              <div style={{ width: "10%", textAlign: "center" }}>
                <Checkbox
                  color={"primary"}
                  checked={portfolioCheck.nonCAD === "y"}
                  onChange={(e) => {
                    actions.setPortfolioValue(
                      props,
                      portfolio.portfolioNumber,
                      "portfolioCheck",
                      {
                        ...portfolioCheck,
                        nonCAD: "y",
                      }
                    );
                  }}
                />
              </div>
              <div style={{ width: "10%", textAlign: "center" }}>
                <Checkbox
                  color={"primary"}
                  checked={portfolioCheck.nonCAD === "n"}
                  onChange={(e) => {
                    actions.setPortfolioValue(
                      props,
                      portfolio.portfolioNumber,
                      "portfolioCheck",
                      {
                        ...portfolioCheck,
                        nonCAD: "n",
                      }
                    );
                  }}
                />
              </div>
            </div>
          </div>
          {portfolioCheck.nonCAD === "y" && (
            <div>
              <Divider />
              <div style={{ display: "flex", margin: 10 }}>
                <div style={{ width: "100%", padding: 15 }}>
                  {portfolio.currencyType === "USD"
                    ? "Are the portfolio’s total market values calculated with foreign assets' values expressed in US dollars using the proper exchange rate, for selling foreign currencies?"
                    : "Are the portfolio’s total market values calculated with foreign assets' values expressed in Canadian dollars using the proper exchange rate, for selling foreign currencies?"}
                </div>
                <div style={{ width: "10%", textAlign: "center" }}>
                  <Checkbox
                    color={"primary"}
                    checked={portfolioCheck.inCAD === "y"}
                    onChange={(e) => {
                      actions.setPortfolioValue(
                        props,
                        portfolio.portfolioNumber,
                        "portfolioCheck",
                        {
                          ...portfolioCheck,
                          inCAD: "y",
                        }
                      );
                    }}
                  />
                </div>
                <div style={{ width: "10%", textAlign: "center" }}>
                  <Checkbox
                    color={"primary"}
                    checked={portfolioCheck.inCAD === "n"}
                    onChange={(e) => {
                      actions.setPortfolioValue(
                        props,
                        portfolio.portfolioNumber,
                        "portfolioCheck",
                        {
                          ...portfolioCheck,
                          inCAD: "n",
                        }
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {portfolioCheck.nonCAD === "y" && portfolioCheck.inCAD === "n" && (
            <div>
              <Divider />
              <div style={{ display: "flex", color: "#3e51b4" }}>
                <div style={{ padding: 10 }}>
                  <Info />
                </div>
                <div>
                  <p>
                    If your portfolio monthly reports only list your Foreign
                    assets in their Foreign currencies, you have two choices.
                  </p>
                  <p>
                    If you wish to convert the Foreign assets’ currencies to the
                    analysis currency, simply replace the listed Foreign
                    currencies month end asset values with the analysis
                    currency, using the Foreign exchange rate at each month end.
                    Similarly, any monthly Contributions, Withdrawals, and
                    Management Fees that were caused by the Foreign assets and
                    listed in a Foreign currency require conversion to the
                    analysis currency.
                  </p>
                  <p>
                    Alternatively, you may omit the Foreign assets from the
                    analyses by removing any Values, Contributions, Withdrawals,
                    and Management Fees that are due to the Foreign assets.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <Divider />
    </div>
  );
};

const Render = PreCheck;

function isComplete(props) {
  const { portfolio } = props;
  const { portfolioCheck = {} } = portfolio;

  var part1 =
    portfolioCheck.nonMarket === "n" ||
    (portfolioCheck.nonMarket === "y" && portfolioCheck.nonGiven);
  var part2 =
    portfolioCheck.nonCAD === "n" ||
    (portfolioCheck.nonCAD === "y" && portfolioCheck.inCAD);

  return !!(part1 && part2);
}

const Preview = (props) => {
  if (!isComplete(props)) {
    return <div>Not Entered</div>;
  }

  return <div>Hi There</div>;
};

const Title = "Analysis PreCheck";
const Description = <div></div>;

export { isComplete, Render, Title, Description, Preview };



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/PreCheck.js